import React from 'react';

import Rating from '../../Rating';
import { RatingColumnValue } from '../types';
import * as styles from './styles/styles.module.scss';

type RatingColumnProps = {
  value: RatingColumnValue;
};

const RatingColumn = ({ value }: RatingColumnProps): JSX.Element => {
  const { rating, timesReviewed } = value;
  const fixedRating = (rating || 0).toFixed(1);
  const title = `${fixedRating} (${timesReviewed || 0})`;

  return (
    <div className={styles.rating} title={title}>
      <Rating rating={rating} />
    </div>
  );
};

export default RatingColumn;
